﻿import { FileInput } from "./fileinput";
import { Url } from "../utilities/url";
import { AsyncFileField } from "./asyncfilefield";
import _ from "underscore";

export class DragAndDropUpload {
  public static get wireup(): string { return '[data-drag-and-drop-upload]'; }

  private DEFAULTS: IDragAndDropUploadOptions = {
    queryParameterName: 'fileCount'
  }

  private options: IDragAndDropUploadOptions;
  private element: HTMLElement;

  public constructor(element: HTMLElement, options?: IDragAndDropUploadOptions) {
    if (element == null)
      throw new Error('You must provide an element to DragAndDropUpload')
    this.element = element;
    this.options = _.extend({}, this.DEFAULTS, this.getOptionsFromElement(), options);
    this.wireUpFileDragAndDrop();
  }

  public static load(element: HTMLElement, options?: IDragAndDropUploadOptions): DragAndDropUpload {
    let dragAndDropUploadElement = element as IDragAndDropUploadElement;
    if (!dragAndDropUploadElement.dragAndDropUpload)
      dragAndDropUploadElement.dragAndDropUpload = new DragAndDropUpload(dragAndDropUploadElement, options);

    return dragAndDropUploadElement.dragAndDropUpload;
  }

  public static wireupDocument(): void {
    $(document).on('draganddropuploadinputsready', (event: JQueryEventObject, data?: any) => {
      if (data === undefined) return;

      let fileFieldsContainer = document.querySelector(data.selector);
      let files = FileInput.droppedFiles;
      let fileFields = fileFieldsContainer.querySelectorAll('[data-file-field]');

      for (let i = 0; i < files.length; i++) {
        let fileField = <AsyncFileField>$(fileFields[i]).data('rustig.asyncfilefield');
        fileField.addFile(files[i]);
      }
    });
  }

  private getOptionsFromElement(): IDragAndDropUploadOptions {
    let options = {} as IDragAndDropUploadOptions;

    if (this.element.getAttribute('data-query-parameter-name'))
      options.queryParameterName = this.element.getAttribute('data-query-parameter-name');

    return options;
  }

  private wireUpFileDragAndDrop(): void {
    $(this.element).fileDragAndDrop({
      onFileDrop: ($dropArea: JQuery, files: Array<File>, event: Event) => {
        this.element.classList.remove('over');

        FileInput.storeDroppedFiles(files);

        let fileCount = files.length;
        let url = this.element.getAttribute('data-url');
        $(this.element).remote({
          url: new Url(url).setQueryParameter(this.options.queryParameterName, fileCount.toString()).toUrl()
        })
      }
    });
  }
}

export interface IDragAndDropUploadElement extends HTMLInputElement {
  dragAndDropUpload: DragAndDropUpload;
}

export interface IDragAndDropUploadOptions {
  queryParameterName: string;
}

export default DragAndDropUpload;

